<template>
  <div class="content-page delivery-page">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="美团" name="11"></el-tab-pane>
      <el-tab-pane label="快手" name="9"></el-tab-pane>
      <el-tab-pane label="抖音" name="10"></el-tab-pane>
    </el-tabs>

    <div class="bd" v-loading="isLoading">
      <div class="tab-header" v-if="!isAddShop">
        <el-button type="primary" size="small" v-if="!isAddShop" :disabled="isAddShop" @click="addShop" plain>添加{{ activeNameObj[activeName] }}门店</el-button>
      </div>
      <div class="tab-content">
        <div class="list">
          <el-table :data="shopList" style="width: 100%">
            <el-table-column label="门店名称">
              <template slot-scope="scope">
                <div class="tag-name">{{ scope.row.stationName }}</div>
              </template>
            </el-table-column>
            <el-table-column label="所在区域">
              <template slot-scope="scope">
                <div class="tag-name">{{ scope.row.areaName }}</div>
              </template>
            </el-table-column>
            <el-table-column label="商户编号">
              <template slot-scope="scope">
                <div class="tag-name">{{ scope.row.shoperUserId }}</div>
              </template>
            </el-table-column>
            <el-table-column label="授权时间">
              <template slot-scope="scope">
                {{ scope.row.modifyTime }}
              </template>
            </el-table-column>
            <el-table-column label="授权过期时间" v-if="activeName == '11'">
              <template slot-scope="scope">
                {{ formatTime(scope.row.expireIn) }}
              </template>
            </el-table-column>
            <el-table-column label="状态">
              <template slot-scope="scope">
                <span :class="scope.row.poiId ? 'green' : 'red'">
                  {{ scope.row.poiId ? "已绑定" : "未绑定" }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" header-align="right" width="300">
              <template slot-scope="scope">
                <div class="float-right">
                  <el-button v-if="activeName == '11'" size="small" type="primary" @click="handleRefreshMtYfAuth" plain>刷新</el-button>
                  <el-button v-if="!(activeName == '11' && scope.row.poiId)" size="small" type="primary" @click="edit(scope.$index)" plain>编辑</el-button>
                  <el-button v-if="activeName == '11' && !scope.row.poiId" size="small" type="primary" @click="handleBindMtYfApp" plain>绑定</el-button>
                  <el-button v-if="scope.row.status != 1" size="small" type="primary" @click="showAuthQrcode" plain>授权</el-button>
                  <el-button type="text" size="small" v-else>已授权</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="pageSize" background layout="prev, pager, next, jumper" :total="shopList.length"></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogAddShopVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="560px" @close="closeAddShopForm">
      <div slot="title" class="dialog-title">添加{{ activeNameObj[activeName] }}门店</div>
      <el-form :model="addShopForm" :rules="addShopFormRule" ref="addShopForm" label-width="128px" class="demo-ruleForm" :validate-on-rule-change="false">
        <el-form-item label="门店名称" prop="stationName">
          <el-input v-model="addShopForm.stationName" placeholder="请填写门店名称"></el-input>
        </el-form-item>
        <el-form-item label="抖音来客账户ID" prop="dyAccountId" v-if="activeName == '10'">
          <el-input v-model="addShopForm.dyAccountId" placeholder="请填写抖音来客账户ID" @blur="accountIdInputBlur"></el-input>
        </el-form-item>
        <el-form-item label="快手用户ID" prop="openUserId" v-if="activeName == '9'">
          <el-input v-model="addShopForm.openUserId" placeholder="请填写快手用户ID" @blur="accountIdInputBlur"></el-input>
        </el-form-item>
        <el-form-item label="商户城市" prop="cityName">
          <el-cascader v-model="addShopForm.cityNameArryay" :options="cityOptionsForCode" @change="cityChange" ref="BCShopCityName" :props="{ expandTrigger: 'hover', value: 'value' }" placeholder="请选择城市"></el-cascader>
        </el-form-item>
        <el-form-item label="店铺地址" prop="stationAddress">
          <el-input v-model="addShopForm.stationAddress" placeholder="请填写店铺地址">
            <!-- <template slot="append">
              <el-button @click="showDialogMap">去定位</el-button>
            </template> -->
          </el-input>
        </el-form-item>
        <el-form-item label="经纬度:" prop="center" v-if="activeName != '11'">
          <el-input v-model="mapCenterInputText" placeholder="请填写经纬度" @blur="mapCenterInputTextBlur(addShopForm)">
            <template slot="append">
              <el-button type="primary" @click="showDialogMap()">去获取</el-button>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="快手商家ID" prop="ksAccountId" v-if="activeName == '9'">
          <el-input v-model="addShopForm.ksAccountId" placeholder="请填写快手商家ID"></el-input>
        </el-form-item>
        <el-form-item :label="`美团商品类型`" v-if="activeName == '11'" prop="goodType">
          <el-radio-group v-model="addShopForm.goodType" :disabled="addShopForm.id ? true : false">
            <el-radio :label="1">到店餐饮</el-radio>
            <el-radio :label="2">到店综合</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="美团门店ID" prop="mtShopId" v-if="activeName == '11'">
          <el-input v-model="addShopForm.mtShopId" placeholder="请填写美团门店ID"></el-input>
        </el-form-item>
        <el-form-item label="点评门店ID" v-if="activeName == '11'">
          <el-input v-model="addShopForm.dpShopId" placeholder="请填写点评门店ID"></el-input>
        </el-form-item>
        <el-form-item label="经营宝管理员账号" prop="mtAccountId" v-if="activeName == '11'">
          <el-input v-model="addShopForm.mtAccountId" placeholder="请填写经营宝管理员账号"></el-input>
        </el-form-item>
        <el-form-item label="商家公司名称" prop="mtAccountName" v-if="activeName == '11'">
          <el-input v-model="addShopForm.mtAccountName" placeholder="请填写商家公司名称"></el-input>
        </el-form-item>
        <el-form-item label="联系人电话" prop="phone" v-if="activeName != '11'">
          <el-input v-model="addShopForm.phone" placeholder="请填写联系人电话"></el-input>
        </el-form-item>
        <el-form-item label="联系人姓名" prop="contactName" v-show="activeName == 'dada'">
          <el-input v-model="addShopForm.contactName" placeholder="请填写联系人姓名"></el-input>
        </el-form-item>
        <el-form-item :label="`抖音来客门店`" v-if="activeName == '10'" prop="poiId">
          <el-select v-model="addShopForm.poiId" filterable remote :remote-method="getShopPoiListSearch" :placeholder="`抖音来客门店`">
            <el-option v-for="item in poiList" :key="item.poi_id" :label="item.poi_name" :value="item.poi_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="`适用${activeNameObj[activeName]}商店`" v-else-if="activeName != '8' && activeName != '11'">
          <el-select v-model="addShopForm.poiId" :placeholder="`请选择适用${activeNameObj[activeName]}商店`">
            <el-option v-for="item in poiList" :key="item.poi_id" :label="item.poi_name" :value="item.poi_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="`团购券是否开启云音箱播报`" v-if="activeName == '10'" prop="speakerOpen">
          <el-select v-model="addShopForm.speakerOpen" :placeholder="`团购券是否开启云音箱播报`">
            <el-option label="关闭" :value="2"></el-option>
            <el-option label="开启" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="`金额播报类型`" v-if="activeName == '10'" prop="amountType">
          <el-select v-model="addShopForm.amountType" :placeholder="`抖音来客门店`">
            <el-option label="实收金额" :value="2"></el-option>
            <el-option label="整单金额" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" label-width="0" v-if="activeName == '10'">
          <span class="red">注:抖音来客门店为必选项，授权后应用后，正确填写抖音来客账户ID，才能正常显示选择。</span>
        </el-form-item>
      </el-form>
      <el-dialog width="510px" :visible.sync="dialogMapVisible" :close-on-click-modal="false" :close-on-press-escape="false" :append-to-body="true">
        <div slot="title" class="dialog-title">地图定位</div>
        <!-- <baidu-map
          v-if="dialogMapVisible"
          class="map"
          :center="center"
          :zoom="zoom"
          @ready="mapBCReadyHandler"
          @click="getBCPoint"
          :scroll-wheel-zoom="true"
        >
          <bm-control :offset="{ width: '10px', height: '10px' }">
            <el-input v-model="keyword" placeholder="请输入地名关键字"></el-input>
          </bm-control>
          <bm-local-search
            :keyword="keyword"
            :auto-viewport="true"
            :location="location"
            zoom="12.8"
            style="display: none"
          ></bm-local-search>
          <bm-marker :position="postionMap">
            <bm-info-window
              :show="show"
              @close="infoWindowClose"
              @open="infoWindowOpen"
              style="font-size: 14px"
            >
              <p>站点：{{ add.siteName }}</p>
              <p>站点地址：{{ add.site }}</p>
            </bm-info-window>
          </bm-marker>
        </baidu-map> -->
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="saveStationAddress">保存</el-button>
        </div>
      </el-dialog>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitAddShop" :loading="isSubmit">{{
          activeName == "shansong" && !addShopForm.bindingMode ? "立即授权" : (addShopForm.id ? "修改" : "立即创建")
        }}</el-button>
        <el-button @click="dialogAddShopVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="visibleQrcodeImg" :close-on-click-modal="false" :close-on-press-escape="false" :title="`${activeNameObj[activeName]}App扫码授权`" :width="activeName != 9 ? '380px' : '800px'" @close="closeAuthQrcode">
      <div style="text-align: center">
        <el-radio-group v-model="tabPosition" v-if="activeName == 10">
          <el-radio-button :label="27">买单</el-radio-button>
          <el-radio-button :label="1">团购</el-radio-button>
        </el-radio-group>
        <qrcode :value="qrcodeImg" :options="{ size: 300 }" class="qrcode" v-if="activeName != 9"></qrcode>
        <img :src="qrcodeImg" class="qrcode" style="width: 100%;" v-else></img>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getMtMerchant,
  queryDyShopPoi,
  queryKsShopPoi,
  getDyAuthUrl,
  addPoiLifeMerchant,
  getAuthUrl,
  ssUploadImg,
  updatePoiLifeMerchant,
  bindMtYfApp,
  getMtYfAuthUrl,
  refreshMtYfAuth,
} from "@/api";
import { gg2bd, bd2gg } from "@/utils/map.js";
import cityJson from "@/assets/js/cityData.json";
import cityJsonForCode from "@/assets/js/citys.json";
import qrcode from "@xkeshi/vue-qrcode";

import { commonFuc } from "@/mixins/commonFuc";

export default {
  mixins: [commonFuc],
  data() {
    return {
      visibleQrcodeImg: false,
      qrcodeImg: "",
      keyword: "",
      location: "",
      show: false,
      postionMap: {
        //地图坐标
        lng: 120.211486,
        lat: 30.256576,
      },
      add: {
        siteName: "",
        site: "",
        jd: "",
        wd: "",
        desce: "",
        type: "",
        jgName: "",
        jgNum: "",
      },
      shopList: [],
      pageSize: 5,
      dialogAddShopVisible: false,
      dialogMapVisible: false,
      addShopForm: {
        stationName: "",
        stationAddress: "",
        phone: "",
        dyAccountId: "",
        cityName: "",
        cityNameArryay: [],
        openUserId: "",
        ksAccountId: "",
        provinceId: "",
        cityId: "",
        districtId: "",
        lng: "",
        lat: "",
        poiId: "",
        dyPoiId: "",
        ksPoiId: "",
        speakerOpen: 1,
        amountType: 1,
        goodType: 1,
        mtShopId: "",
        dpShopId: "",
        mtAccountId: "",
        mtAccountName: "",
      },
      isBindAccount: false,
      isAddShop: false,
      addShopFormRule: {
        goodType: [
          {
            required: true,
            message: "请选择美团商品类型",
            trigger: "change",
          },
        ],
        mtShopId: [
          {
            required: true,
            message: "请填写美团门店ID",
            trigger: "blur",
          },
        ],
        dpShopId: [
          {
            required: true,
            message: "请填写点评门店ID",
            trigger: "blur",
          },
        ],
        mtAccountId: [
          {
            required: true,
            message: "请填写美团管家账号ID",
            trigger: "blur",
          },
        ],
        mtAccountName: [
          {
            required: true,
            message: "请填写美团管家账号名称",
            trigger: "blur",
          },
        ],
        phone: [
          {
            pattern: /^1[123456789]\d{9}$/,
            required: true,
            message: "请填写正确的手机号",
            trigger: "blur",
          },
        ],
        stationName: [
          {
            required: true,
            message: "请填写门店名称",
            trigger: "blur",
          },
        ],
        cityName: [
          {
            required: true,
            message: "请选择城市",
            trigger: "blur",
          },
        ],
        stationAddress: [
          {
            required: true,
            message: "请填写企业地址",
            trigger: "blur",
          },
        ],
        dyAccountId: [
          {
            required: true,
            message: "请填写抖音来客账户ID",
            trigger: "blur",
          },
        ],
        openUserId: [
          {
            required: true,
            message: "请填写快手用户ID",
            trigger: "blur",
          },
        ],
        ksAccountId: [
          {
            required: true,
            message: "请填写快手商家ID",
            trigger: "blur",
          },
        ],
        poiId: [
          {
            required: true,
            message: "请选择适用商店",
            trigger: "blur",
          },
        ],
        speakerOpen: [
          {
            required: true,
            message: "请选择团购券是否开启云音箱播报",
            trigger: "blur",
          },
        ],
        amountType: [
          {
            required: true,
            message: "请选择金额播报类型",
            trigger: "blur",
          },
        ],
      },
      cityOptions: cityJson,
      cityOptionsForCode: cityJsonForCode,
      poiList: [],
      mapCenter: "",
      mapCenterInputText: "",
      center: { lng: 0, lat: 0 },
      zoom: 12.8,
      isSubmit: false,
      activeName: "9",
      activeNameObj: {
        11: "美团",
        9: "快手",
        10: "抖音",
      },
      eleInfo: null,
      timer: null,
      timeCount: 60,
      isShowAPDialog: false,
      isLoading: false,
      tabPosition: 27
    };
  },
  watch: {
    bindingMode(value, old) {
      this.$refs.addShopForm.resetFields();
    },
    activeName() {
      this.getPageData();
    },
    tabPosition() {
      this.showAuthQrcode();
    }
  },
  components: {
    qrcode,
  },
  computed: {
    bindingMode() {
      return this.addShopForm.bindingMode;
    },
  },
  mounted() {
    this.getPageData();
  },
  methods: {
    formatTime(timestamp) {
      if (!timestamp) return "";
      let time = String(timestamp).length === 10 ? timestamp * 1000 : timestamp;
      let date = new Date(parseInt(time));
      let y = date.getFullYear();
      let m = (date.getMonth() + 1).toString().padStart(2, '0');
      let d = date.getDate().toString().padStart(2, '0');
      let h = date.getHours().toString().padStart(2, '0');
      let min = date.getMinutes().toString().padStart(2, '0');
      let s = date.getSeconds().toString().padStart(2, '0');
      return `${y}-${m}-${d} ${h}:${min}:${s}`;
    },
    getPageData() {
      this.getMtMerchant();
    },
    getMtMerchant() {
      this.isLoading = true;
      getMtMerchant({
        sendType: this.activeName,
      }).then((res) => {
        if (res.code == 1) {
          this.shopList = [res.data];
          // this.shopList.push(res.data);
          this.isAddShop = true;
        } else {
          this.shopList = [];
          this.isAddShop = false;
        }
        this.isLoading = false;
      });
    },
    getAuthUrl() {
      getAuthUrl().then((res) => {
        if (res.code == 1) {
          location.href = res.data.url;
        }
      });
    },
    accountIdInputBlur() {
      this.addShopForm.poiId = "";
      this.getShopPoiList()
    },
    getShopPoiList() {
      if (this.activeName == "10") {
        queryDyShopPoi({
          dyAccountId: this.addShopForm.dyAccountId
        }).then((res) => {
          if (res.code == 1) {
            this.poiList = res.data.map((val) => {
              return val.poi;
            });
          }
          if (res.code == -1) {
            this.poiList = [];
          }
        });
      } else if (this.activeName == "9") {
        queryKsShopPoi().then((res) => {
          if (res.code == 1) {
            this.poiList = res.data.map((val) => {
              return val.poi;
            });
          }
          if (res.code == -1) {
            this.poiList = [];
          }
        });
      }
    },
    getShopPoiListSearch(query = "") {
      if (query !== '') {
        setTimeout(() => {
          queryDyShopPoi({
            dyAccountId: this.addShopForm.dyAccountId,
            poiId: query
          }).then((res) => {
            if (res.code == 1) {
              this.poiList = res.data.map((val) => {
                return val.poi;
              });
            } else {
              this.poiList = [];
              this.$notify({
                title: "提示",
                message: res.msg,
                type: "warning",
              });
            }
          });
        }, 500);
      } else {
        this.getShopPoiList()
      }
    },
    mapBCReadyHandler({ BMap, map }) {
      this.center = this.mapBCCenter;
      this.zoom = 12.8;
    },
    getBCPoint(e) {
      //点击地图获取一些信息，
      this.show = true;
      this.postionMap.lng = e.point.lng; //通过  e.point.lng获取经度
      this.postionMap.lat = e.point.lat; //通过  e.point.lat获取纬度
      this.add.jd = e.point.lng;
      this.add.wd = e.point.lat;
      this.zoom = e.target.getZoom();

      let geocoder = new BMap.Geocoder(); //创建地址解析器的实例
      geocoder.getLocation(e.point, (rs) => {
        this.add.site = rs.address;
        this.add.lng = rs.point.lng;
        this.add.lat = rs.point.lat;
        this.addShopForm.stationAddress = rs.address;
        let { lng, lat } = bd2gg(rs.point.lng, rs.point.lat);
        this.addShopForm.lng = lng;
        this.addShopForm.lat = lat;
      });
    },
    infoWindowClose() {
      this.show = false;
    },
    infoWindowOpen() {
      setInterval(() => {
        this.show = true;
      }, 100);
    },
    addShop() {
      this.dialogAddShopVisible = true;
    },
    // showDialogMap() {
    //   if (!this.addShopForm.cityNameArryay.length) {
    //     this.$notify({
    //       title: "警告",
    //       message: "请先选择城市",
    //       type: "warning",
    //       duration: 6000,
    //     });
    //     return;
    //   }
    //   this.dialogMapVisible = true;
    // },
    saveStationAddress() {
      this.dialogMapVisible = false;
    },
    closeAddShopForm() {
      if (this.$refs.addShopForm) {
        this.$refs.addShopForm.resetFields();
      }
      this.addShopForm = {
        stationName: "",
        stationAddress: "",
        phone: "",
        dyAccountId: "",
        cityName: "",
        cityNameArryay: [],
        openUserId: "",
        ksAccountId: "",
        provinceId: "",
        cityId: "",
        districtId: "",
        lng: "",
        lat: "",
        poiId: "",
        dyPoiId: "",
        ksPoiId: "",
        speakerOpen: 1,
        amountType: 1,
        goodType: 1,
        mtShopId: "",
        dpShopId: "",
        mtAccountId: "",
        mtAccountName: "",
      };
      this.mapCenterInputText = "";
      this.mapCenter = "";
      this.poiList = [];
    },
    submitAddShop() {
      this.$refs.addShopForm.validate((valid) => {
        if (valid) {
          this.isSubmit = true;
          let params = JSON.parse(JSON.stringify(this.addShopForm));
          params.enterpriseName = params.stationName;
          // params.provinceId = params.cityNameArryay[0][0];
          // params.cityId = params.cityNameArryay[1][0];
          // params.districtId = params.cityNameArryay[2][0];
          // params.provinceName = params.cityNameArryay[0][1];
          // params.areaName = params.cityNameArryay[2][1];
          // params.cityName = params.cityNameArryay[1][1];
          params.provinceId = params.cityNameArryay[0];
          params.cityId = params.cityNameArryay[1];
          params.districtId = params.cityNameArryay[2];
          delete params.cityNameArryay;
          if (this.activeName == "9") {
            params.ksPoiId = params.poiId;
          } else if (this.activeName == "10") {
            params.dyPoiId = params.poiId;
          }
          if (this.activeName == "9") {
            params.accountId = params.ksAccountId;
          } else if (this.activeName == "10") {
            params.accountId = params.dyAccountId;
          }
          params.sendType = this.activeName;
          if (params.id) {
            updatePoiLifeMerchant(params).then((res) => {
              if (res.code == 1) {
                this.$notify({
                  title: "提示",
                  message: "编辑成功",
                  type: "success",
                });
                this.getPageData();
                this.dialogAddShopVisible = false;
              } else {
                this.$notify({
                  title: "提示",
                  message: res.msg,
                  type: "warning",
                });
              }
              setTimeout(() => {
                this.isSubmit = false;
              }, 500);
            });
          } else {
            addPoiLifeMerchant(params).then((res) => {
              if (res.code == 1) {
                this.$notify({
                  title: "提示",
                  message: "创建成功",
                  type: "success",
                });
                this.getPageData();
                this.dialogAddShopVisible = false;
              } else {
                this.$notify({
                  title: "提示",
                  message: res.msg,
                  type: "warning",
                });
              }
              setTimeout(() => {
                this.isSubmit = false;
              }, 500);
            });
          }
        } else {
          this.$notify({
            title: "提示",
            message: "请完善提交内容",
            type: "error",
            duration: 2000,
          });
          return false;
        }
      });
    },
    cityChange(value) {
      this.addShopForm.provinceId = value[0];
      this.addShopForm.cityId = value[1];
      this.addShopForm.districtId = value[2] || -1;
      let cityName = "";
      this.cityOptionsForCode.forEach((val) => {
        if (val.value == value[0]) {
          cityName += val.label;
          this.addShopForm.provinceName = val.label;
          val.children.forEach((sval) => {
            if (sval.value == value[1]) {
              cityName += sval.label;
              this.addShopForm.cityName = sval.label;
              if (value[2] != -1) {
                sval.children.forEach((ssval) => {
                  if (ssval.value == value[2]) {
                    cityName += ssval.label;
                    this.addShopForm.areaName = ssval.label;
                  }
                });
              }
            }
          });
        }
      });
      this.mapCenter = cityName;
    },
    handleSizeChange() { },
    handleCurrentChange() { },
    handleBindMtYfApp() {
      this.$confirm("绑定后将无法修改，是否确定绑定?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        bindMtYfApp().then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "绑定成功",
              type: "success",
            });
            this.getPageData();
          } else {
            this.$notify({
              title: "提示",
              message: res.msg || "绑定失败",
              type: "error",
            });
          }
        });
      }).catch(() => { });
    },
    edit(index) {
      let params = JSON.parse(JSON.stringify(this.shopList[index]));
      params.cityNameArryay = [
        String(params.provinceId),
        String(params.cityId),
        String(params.districtId),
        // [String(params.provinceId), params.provinceName],
        // [String(params.cityId), params.cityName],
        // [String(params.districtId), params.areaName],
      ];
      if (this.activeName == "10") {
        params.dyAccountId = params.accountId;
      } else if (this.activeName == "9") {
        params.ksAccountId = params.accountId;
      }
      this.mapCenter = params.provinceName + params.cityName + params.areaName;
      // params = Object.assign(this.addShopForm, params);
      // this.addShopForm = {};
      this.addShopForm = params;
      // Object.assign(this.addShopForm, params);
      this.mapCenterInputText = params.longitude ? `${params.longitude},${params.latitude}` :
        params.lng ? `${params.lng},${params.lat}` : ``;
      console.log(this.addShopForm);
      this.dialogAddShopVisible = true;
      this.getShopPoiList();
    },
    handleSuccess(item, type) {
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", item.file);
      imgUploadForm.append("fileContentType", item.file.type);
      imgUploadForm.append("fileFileName", item.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);
      ssUploadImg(imgUploadForm).then((res) => {
        console.log(res);
        if (res.code == 1) {
          console.log(type);
          if (type == "frontIdcard") {
            this.addShopForm.frontIdcard = res.data.url;
          }
          if (type == "reverseIdcard") {
            this.addShopForm.reverseIdcard = res.data.url;
          }
          if (type == "businessLicense") {
            this.addShopForm.businessLicense = res.data.url;
          }
          if (type == "facade") {
            this.addShopForm.facade = res.data.url;
          }
        }
      });
    },
    closeAuthQrcode() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    handleRefreshMtYfAuth() {
      refreshMtYfAuth().then(refRes => {
        if (refRes.code == 1) {
          this.$notify({
            title: "提示",
            message: "刷新授权成功",
            type: "success",
          });
          this.getPageData();
        } else {
          this.$notify({
            title: "提示",
            message: refRes.msg || "刷新授权失败",
            type: "warning",
          });
        }
      });
    },
    showAuthQrcode() {
      if (this.activeName == '11') {
        getMtYfAuthUrl({
          sendType: this.activeName,
        }).then((res) => {
          if (res.code == 1) {
            this.qrcodeImg = res.data.authUrl;
            this.visibleQrcodeImg = true;
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
            });
          }
        });
      } else {
        getDyAuthUrl({
          sendType: this.activeName,
          solutionKey: this.tabPosition
        }).then((res) => {
          if (res.code == 1) {
            this.qrcodeImg = res.data.authUrl;
            this.visibleQrcodeImg = true;
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
            });
          }
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .el-tabs {
    margin: 10px 10px 0 10px;
  }

  .tab-content {
    display: block;
    padding: 0 20px;
  }

  .el-cascader,
  .el-select {
    width: 100%;
  }
}

.green {
  color: green;
}

.red {
  color: red;
}

.map {
  width: 100%;
  height: 400px;

  /deep/ .anchorBL {
    display: none;
  }
}

.uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 178px;
  height: 178px;

  &:hover {
    border-color: #409eff;
  }
}

.uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.uploader .el-upload:hover {
  border-color: #409eff;
}

.uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.uploader-img {
  width: 178px;
  height: 178px;
  display: block;
}
</style>

<style lang="less">
.delivery-page {

  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 160px;
  }
}

.el-form-item__content {
  .el-input-group__append {
    background: #fff;
  }
}
</style>
